import { render } from "./ConnectAccountDialog.vue?vue&type=template&id=2b957be1"
import script from "./ConnectAccountDialog.vue?vue&type=script&lang=js"
export * from "./ConnectAccountDialog.vue?vue&type=script&lang=js"

import "./ConnectAccountDialog.vue?vue&type=style&index=0&id=2b957be1&lang=scss&scope=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__